<div class="p-4">
  <div class="d-flex justify-content-between">
    <div class="card-sub-heading my-3 title_size20">Summary</div>
    <button mat-icon-button (click)="this.dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <div class="d-flex justify-content-between my-2">
    <div class="card-sub-heading bold">
      {{ props.FirstName }} {{ props.LastName }}
    </div>
    <div class="d-flex">
      <div class="">Order#:</div>
      <div class="bold ml-2">{{ props.OrderID }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-between border-bottom pb-3">
    <div class="card-sub-heading">
      <span *ngIf="props?.Unit">Unit {{ props.Unit }}, </span>
      <span>{{ props?.Address1 ? props.Address1 : '' }}{{ props?.City ? ', ' + props.City : '' }}{{ props?.Prov ? ', ' + props?.Prov : '' }}{{ props?.Postal ? ', ' + props?.Postal : '' }}{{ props?.Country ? ', ' + props?.Country : '' }}</span>
    
      <ng-container *ngIf="props?.requestOrderId == 0 && props?.Address2 !== 'DO NOT SHIP'">
        <span>{{ props.Address2 }}</span>
      </ng-container>
    
      <ng-container *ngIf="props?.BuzzerCode">
        <div>Buzzer Code: {{ props.BuzzerCode }}</div>
      </ng-container>
    </div>

    <div class="d-flex">
      <div class="">Date:</div>
      <div class="bold ml-2">
        {{ helperService.getSlashDate(props.created_at) }}
      </div>
    </div>
  </div>
  <div class="card-sub-heading bold my-3">Rx Details</div>
  <div class="pagination-table" style="overflow-x: scroll">
    <table class="table" aria-describedby="Rx Details table">
      <thead>
        <tr>
          <th>RX ID</th>
          <th>Quantity</th>
          <th>Drug Name</th>
          <th>DIN</th>
          <th>Fill Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of props?.sale_order_rx_detail">
          <td>{{ item.RxNum }}</td>
          <td>{{ item.DispQty }}</td>
          <td>{{ item.kroll_drg?.GenericName }}</td>
          <td>{{ item.kroll_drg?.DIN }}</td>
          <td>{{ helperService.getSlashDate(item.FillDate) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row border-bottom pb-1 my-3">
    <div class="col-md-6 border-right">
      <div class="">
        <div class="d-flex justify-content-between p-2">
          <div class="">Kroll ID</div>
          <div class="bold">
            {{ props.KrollID }}
          </div>
        </div>
  
        <div class="d-flex justify-content-between p-2">
          <div class="">Packaging</div>
          <div class="bold">
            {{ props.Packaging }}
          </div>
        </div>
  
        <div class="d-flex justify-content-between p-2">
          <div class="">Packaging Cost</div>
          <div class="bold">
            {{ props.PackagingCost }}
          </div>
        </div>
        <div class="d-flex justify-content-between p-2">
          <div class="">Delivery Cost</div>
          <div class="bold">{{props?.DeliveryCost? props?.DeliveryCost : '0' }}</div>
        </div>
        <div class="d-flex justify-content-between p-2">
          <div class="">Total Med Cost</div>
          <div class="bold">
            {{ props.TotalMedCost }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="">
        <div class="d-flex justify-content-between p-2">
          <div class="">Delivery Partner</div>
          <div class="bold d-flex justify-content-end">
            {{ props.deliver_partner ? props.deliver_partner.name : "-" }}
          </div>
        </div>
  
        <div class="d-flex justify-content-between p-2" >
          <div class="">Option</div>
          <div class="bold d-flex justify-content-end">
            {{ this.showOptionCode ? this.showOptionCode?.join(', ') : "-" }}
          </div>
        </div>
  
        <div class="d-flex justify-content-between p-2" >
          <div class="">Discovery Service</div>
          <div class="bold d-flex justify-content-end">
            {{ this.serviceCode ? this.serviceCode : "-" }}
          </div>
        </div>
  
        <div class="d-flex justify-content-between p-2">
          <div class="">Processed By</div>
          <div class="bold">
            <div class="d-flex justify-content-end">
              {{ props.processed_by ? props.processed_by.display_name : "-" }}
            </div>
            <div class="d-flex justify-content-end mt-1">
              {{
                props.processed_at
                  ? helperService.getDate(props.processed_at)
                  : ""
              }}
            </div>
            <div class="d-flex justify-content-end mt-1">
              {{
                props.processed_at
                  ? helperService.getTime(props.processed_at)
                  : ""
              }}
            </div>
          </div>
        </div>
  
        <div class="d-flex justify-content-between p-2 mt-2">
          <div class="">Tracking ID</div>
          <div class="bold">
            {{ props.TrackingID }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="border-bottom pb-1 my-3">
    <div class="d-flex justify-content-between p-2">
      <div class="">Payment Due</div>
      <div class="bold">
        {{ paymentDue }}
      </div>
    </div>
  
    <div class="d-flex justify-content-between p-2">
      <div class="">Status</div>
      <div class="bold">
        {{ props.SalesOrderStatus }}
      </div>
    </div>
  
    <div class="d-flex justify-content-between p-2">
      <div class="">Delivery Partner</div>
      <div class="bold">
        {{ props.deliver_partner ? props.deliver_partner.name : "-" }}
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between mt-3 p-2">
    <div class="card-sub-heading bold">Payment</div>
    <div class="green">
      {{ getPaymentType() }}
    </div>
  </div>
  
</div>
